import React from 'react';

import LegalDocumentPage from './LegalDocumentPage';
import privacyPolicy from '../content/legal/privacyPolicy';

const PrivacyPolicy = () => (
  <LegalDocumentPage
    document={privacyPolicy}
    seo={{
      title: 'Privacy Policy | Mutawir Studios',
      description: 'Learn how Mutawir Studios collects, uses, and protects personal information shared through our website and services.'
    }}
  />
);

export default PrivacyPolicy;
